/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tpm_Modal_TitleInputs */

const en_tpm_modal_title = /** @type {(inputs: Tpm_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TPM`)
};

const ja_tpm_modal_title = /** @type {(inputs: Tpm_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TPM`)
};

const fr_tpm_modal_title = /** @type {(inputs: Tpm_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TPM`)
};

const de_tpm_modal_title = /** @type {(inputs: Tpm_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TPM`)
};

/**
* | output |
* | --- |
* | "TPM" |
*
* @param {Tpm_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const tpm_modal_title = /** @type {((inputs?: Tpm_Modal_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tpm_Modal_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tpm_modal_title(inputs)
	if (locale === "ja") return ja_tpm_modal_title(inputs)
	if (locale === "fr") return fr_tpm_modal_title(inputs)
	return de_tpm_modal_title(inputs)
});